module.exports = __webpack_public_path__ + "img/7_9.68772851.png";